import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api/api.service';
import { Trigger } from 'src/app/models/trigger';

@Injectable({
  providedIn: 'root',
})
export class TimingRulesService {
  saveTimingRules(
    studyId: number,
    interventionId: number,
    moduleId: number,
    triggers: Trigger[]
  ): Observable<Trigger[]> {
    return this.apiService.put<Trigger[]>(
      `/dashboard/study/${studyId}/intervention/${interventionId}/module/${moduleId}/triggers`,
      triggers
    );
  }

  esmTriggerEditable(
    studyId: number,
    interventionId: number,
    moduleId: number,
  ): Observable<boolean> {
    return this.apiService.get<boolean>(
      `/dashboard/study/${studyId}/intervention/${interventionId}/module/${moduleId}/esm-trigger-editable`
    );
  }


  constructor(private apiService: ApiService) {}
}
